// contacts
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

import WebbDividerSmall from "../webx/webb-divider-sm";
import WebbDividerMedium from "../webx/webb-divider-md";
import WebbLoader from "../webx/webb-loader";
import WebbModuleInfo from "../webx/webb-module-info";

import FileSaver from "../../services/srvc-filesaver";

import { GetUserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { CollectionsList } from "../../services/srvc-store-realm";
import { MediaCreate } from "../../services/srvc-media-realm";

// code --------------->
import { Form, Input, InputNumber, Button, Result, Space, Select  } from 'antd';
const { TextArea } = Input;
const { Option } = Select;

export default function MediaCreateModule() {

  const usxx = GetUserForm();
  const asset = GetUserForm() === "in" ? GetLocalUser() : GetLocalBusiness();

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [done, setDone] = useState(false);
  const [check, setCheck] = useState(true);

  const history = useHistory();

  const [file, setFile] = useState();
  const [store, setStore] = useState();
  const [mode, setMode] = useState([
    {name: 'Public', actv: true},
    {name: 'Tokens', actv: false},
    {name: 'Invite', actv: false}
  ])
  const [format, setFormat] = useState([
    {name: 'Graphics', actv: true},
    {name: 'Audio', actv: false},
    {name: 'Video', actv: false}
  ])
  const [list, setList] = useState();
  const [data, setData] = useState({
    name: '',
    memo: '',
    form: '',
    sort: '',
    file: '', // datastring,
    mode: ''
  })

  useEffect( async () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);
        
        const result = await CollectionsList({
          data: {user: asset.usid},
          user: asset.usid
        })
        console.log (result.data.store)
        setList(result.data.store)

        setLoading(false);
      }
      fetchData()
    } else {}
  },[]);


  // useEffect for form validation
  useEffect( () => {
    // setCheck(false);
    // if (data.name!=='' && data.memo!=='' && file!=='')  setCheck(true);
  },[data, file]);

  const onFinish = async (values) => {

    setSubmit(true)
    setLoading(true)
    
    const datx = {
      "name": values.name ??= '***',
      "memo": values.memo ??= '***',
      "form": format.find(x => x.actv).name,
      "sort": "",
      "mode": mode.find(x => x.actv).name,
      "rate": (values.rate).toString(),
      "store": values.store,
      file: file,
    }
    console.log (datx)

    const result = await MediaCreate({data: datx, user: asset.usid})

    if (result.data) {
      setDone(true)
    }
    else {setDone(false)}
    setLoading(false)

  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleChange = (item) => {
    // edit array-object value
    console.log ('store: ', item)
    setStore(item);
  };

  const handleFeature = async (feat, indx) => {
    // edit array-object value
    
    if (feat==='mode') setMode(mode.map((item, x) => x===indx ? {...item, actv: true} :  {...item, actv: false}));
    if (feat==='form') setFormat(format.map((item, x) => x===indx ? {...item, actv: true} :  {...item, actv: false}))
    
  };

  const SetFileBase = async(base) => {
    // console.log (base);
    setFile(base);
  }


  if (loading) return <WebbLoader/>
  if (list && list.length===0) return <>
    <div className="p-3 text-center text-color-tone">
      Please <Link to={`/${usxx}/collections/create`}>Create a Collection</Link> first.
    </div> 
  </>

  return (
  <>

    {/* info */}
    <div className={submit ? 'd-none' : ''}>
      <WebbModuleInfo data={{text:'Create Media'}} />
      <WebbDividerSmall />
    </div>
    
    {/* data */}
    <div className={submit ? 'd-none' : ''}>
      <Form
        name="data"
        layout="vertical"
        initialValues={{ }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >

      <Form.Item
        label="Select Collection"
        name="store"
        rules={[{ required: true, message: 'Please select collection' }]}
      >
        <Select
          size="large"
          bordered={false}
          style={{ width: '100%', fontSize:'0.9rem'}}
          className="border rounded-wd"
          onChange={handleChange}
        >
          {list && list.map((item, i) => (
            <Option value={item.store} key={i}>{item.name}</Option>
          ))}
          
        </Select>
      </Form.Item>

      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: 'Please enter Media Name' }]}
      >
        <Input placeholder="Media Name" className="height-md rounded-wd"/>
      </Form.Item>

      <Form.Item
        label="Description"
        name="memo"
        rules={[{ required: true, message: 'Please enter description' }]}
      >
       <TextArea rows={3} placeholder="Media Description" className="rounded-wd" />
      </Form.Item>

      <Form.Item
        label="List Price"
        name="rate"
        rules={[{ required: true, message: 'Please enter list price' }]}
      >
        <Input placeholder="0.00" className="height-md rounded-wd"/>
      </Form.Item>

      {/* artwork  */}
      <p className=""><span style={{color:'red'}}>*</span> Media Artwork / Content</p>
      <FileSaver base = {SetFileBase}/>


      <div className="d-none">
        <p className=""><span style={{color:'red'}}>*</span> Content Format</p>
        {/* feat */}
        <Space className="" >
          {format && format.map((item, i) => (
            <div className={`p-2 py-1 rounded-wd hilite cursor border ${item.actv ? 'back-color-next text-color-wite' : ''}`}
              key={i}  
              onClick = {() => handleFeature('form', i)}
            >{item.name}</div>
          ))}
        </Space>
      </div>

      <WebbDividerMedium />
      <div className="">
        <p className=""><span style={{color:'red'}}>*</span> Access</p>
        {/* feat */}
        <Space className="" >
          {mode && mode.map((item, i) => (
            <div className={`p-2 py-1 rounded-wd hilite cursor border ${item.actv ? 'back-color-next text-color-wite' : ''}`} 
              key={i}
            >{item.name}</div>
          ))}
        </Space>
      </div>


      <WebbDividerMedium />
      <WebbDividerMedium />

        <Form.Item wrapperCol={{}}>
          <Button 
            type="primary" htmlType="submit" 
            className="height-md rounded-wd back-color-next border-none" 
            disabled={!check}
            style={{width:'100%'}}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>


    {/* result */}
    <div className={submit ? 'back-color-wite text-center mb-3' : 'd-none'}>
      <WebbDividerSmall />
      
      <Result
        status="success"
        title="Congratulations!"
        subTitle="Your Media is Created."
        className={done ? '' : 'd-none'}
        extra={[
          <Button type="primary" key="home" 
            className="back-color-next border-none rounded-wd"
            onClick={()=>history.push(`/${usxx}/cx/v/${store}`)}>
            Collection
          </Button>,
          <Button key="reload" 
            className="rounded-wd"
            onClick={()=> setSubmit(false)}>
          New Media</Button>,
        ]}
      />
      
      <Result
        status="warning"
        title="Error!"
        subTitle="Please try again."
        className={done ? 'd-none' : ''}
        extra={[
          <Button type="primary" key="home" 
            className="back-color-next border-none rounded-wd"
            onClick={()=>history.push(`/${usxx}/collection/${store}`)}>
            Collection
          </Button>,
          <Button key="reload" 
            className="rounded-wd"
            onClick={()=> setSubmit(false)}>
          Try Again</Button>,
        ]}
      />

    </div>


  </>

  )
}